import React, { useState } from "react";
import { BookOpen, Zap, Mail, CalendarCheck } from "lucide-react";
import { db } from "../../firebase1";            // ← Your Firebase config
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const Workshop = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      await addDoc(collection(db, "workshopEmails"), {
        email: email,
        timestamp: serverTimestamp(),
      });

      setMessage("You're added to the priority list!");
      setEmail("");
    } catch (error) {
      setMessage("❌ Something went wrong. Please try again.");
      console.error("Error saving email:", error);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-teal-50 to-purple-100 flex items-center justify-center p-6 font-sans">

      <div className="max-w-3xl w-full bg-white p-10 md:p-16 rounded-3xl shadow-2xl border-t-8 border-purple-600 text-center">

        <BookOpen className="w-20 h-20 text-purple-600 mx-auto mb-6 animate-bounce" />

        <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 mb-4">
          Workshops Coming Soon!
        </h1>

        <p className="text-xl text-gray-600 mb-8 max-w-lg mx-auto">
          We are crafting <span className="font-semibold">interactive learning sessions</span> 
          to boost your skills and imagination.
        </p>

        <hr className="my-10 border-dashed border-gray-300" />

        <h2 className="text-2xl font-bold text-purple-700 mb-3 flex justify-center gap-2">
          <CalendarCheck className="w-6 h-6" />
          Get Notified Early
        </h2>

        <p className="text-lg text-gray-700 mb-6">
          Join the <span className="font-semibold">priority list</span> and be the first to know.
        </p>

        {/* Email Submit Form */}
        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-4 justify-center mt-6"
        >
          <input
            type="email"
            placeholder="Enter your best email"
            value={email}
            required
            onChange={(e) => setEmail(e.target.value)}
            className="w-full sm:w-80 p-3 border-2 border-gray-300 rounded-xl focus:border-purple-600 focus:ring-purple-500 text-lg shadow-inner transition"
          />

          <button
            type="submit"
            disabled={loading}
            className={`flex items-center justify-center gap-2 px-6 py-3 rounded-xl text-white font-bold text-lg shadow-lg transition active:scale-95
              ${loading ? "bg-purple-300" : "bg-purple-600 hover:bg-purple-700"}`}
          >
            <Mail className="w-5 h-5" />
            {loading ? "Submitting..." : "Get Updates"}
          </button>
        </form>

        {/* Message */}
        {message && (
          <p className="mt-5 text-lg font-semibold text-green-600">
            {message}
          </p>
        )}

        <div className="mt-10 text-sm text-gray-600">
          <p>
            Have questions? Contact us anytime!{" "}
            {/* <Zap className="inline w-4 h-4 text-yellow-500" /> */}
          </p>
        </div>

      </div>
    </div>
  );
};

export default Workshop;
